import React from 'react';

const DoubleCheckIcon = function DoubleCheckIcon() {
  return (
    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg" className="double-check-icon">
      <rect x="7.7033" y="6.7033" width="21.5934" height="21.5934" rx="4.92308" fill="white" stroke="#1EC252" strokeWidth="1.40659" />
      <path d="M25.0247 11C22.3313 13.8312 19.2182 17.0876 16.4329 20.012L11.818 15.9048L10 18.1418L15.5938 23.1291L16.5815 24L17.4905 23.0465C20.4716 19.9129 24.0144 16.2104 27 13.0719L25.0247 11V11Z" fill="#1EC252" />
      <rect x="0.703297" y="0.703297" width="21.5934" height="21.5934" rx="4.92308" fill="white" stroke="#1EC252" strokeWidth="1.40659" />
      <path d="M18.0247 5C15.3313 7.83125 12.2182 11.0876 9.43291 14.012L4.818 9.9048L3 12.1418L8.59383 17.1291L9.58148 18L10.4905 17.0465C13.4716 13.9129 17.0144 10.2104 20 7.07193L18.0247 5V5Z" fill="#1EC252" />
    </svg>
  );
};

export default DoubleCheckIcon;
